<template>
  <el-container class="design-container">
    <el-main
      style="position: relative; width: 100vw; height: 100vh; display: flex"
    >
      <div class="product-info">
        <div>模型名称：{{ productInfo.zh_cn_title }}</div>
        <div class="m-l-20">模型编号：{{ productInfo.code }}</div>
        <div class="m-l-20">
          效果图类型：{{ productInfo.effectimg_type == 1 ? "模型" : "PSD" }}
        </div>
        <div class="m-l-20">
          生产图类型：{{
            { 1: "SVG", 2: "烫画", 3: "PSD" }[productInfo.factoryimg_type] ||
            "未知"
          }}
        </div>
        <div class="m-l-20">
          是否为定制设计：
          <span class="primary" v-if="isDesign">是</span>
          <span v-else>否</span>
        </div>
      </div>
      <div class="origin-imgs">
        <div class="m-t-10">原始图片：</div>
        <el-image
          v-for="(item, index) in origin_images"
          :key="index"
          :src="item + '?x-oss-process=image/resize,w_50,h_50'"
          :preview-src-list="origin_images"
          style="
            width: 50px;
            height: 50px;
            border: 1px solid #999;
            margin: 10px;
          "
        />
        <el-button type="text" @click="downloadOriginImage">下载</el-button>
      </div>
      <div class="font-list">
        <span>使用字体：</span>
        <span
          v-for="(item, index) in useFontList"
          :key="index"
          class="m-l-10"
          >{{ item }}</span
        >
      </div>
      <div id="workspace" class="design-workspace">
        <div class="design-face-cont">
          <div
            class="design-face-item"
            v-for="(item, index) in designFaceData"
            :key="index"
            :class="faceIndex == index ? 'on' : ''"
            @click="faceIndex = index"
            v-show="isCommonDesignFace(item) && faceIsShow(item)"
          >
            <el-tooltip
              effect="dark"
              :content="item.zh_cn_name"
              placement="top-start"
            >
              <el-button style="padding: 0">
                <img
                  :src="item.img + '?x-oss-process=image/resize,w_80,h_80'"
                  alt=""
                />
              </el-button>
            </el-tooltip>
          </div>
        </div>
        <div class="editor-canvas">
          <div
            class="editor-canvas-bg"
            :style="{
              width: canvasW * zoomScale + 'px',
              height: canvasH * zoomScale + 'px',
            }"
          ></div>
          <fabric-editor
            v-for="(item, index) in designFaceData"
            v-show="index == faceIndex"
            :key="index"
            :index="index"
            :value="item"
            :width="canvasW"
            :height="canvasH"
            :left="designFaceShiftX"
            :top="designFaceShiftY"
            ref="editor"
            @zoomChange="handleZoomChange"
            @confirm="setCanvas(index)"
          ></fabric-editor>
        </div>
      </div>
      <div class="design--right">
        <div style="margin: 10px">
          <!-- 效果图  -->
          <div class="design-effect">
            <div class="effect-preview" v-if="effectData.length > 0">
              <el-carousel
                v-if="effectimg_type == 1"
                :height="600 + 'px'"
                arrow="always"
                :autoplay="false"
                trigger="click"
              >
                <el-carousel-item
                  v-for="(item, index) in effectData"
                  :key="index"
                  :name="item.design_name"
                >
                  <effect
                    ref="effectRef"
                    :modelId="
                      productInfo && productInfo.model
                        ? productInfo.model.id
                        : undefined
                    "
                    :value="item"
                    :id="index"
                    :type="2"
                    :imgLayer="
                      currentSpecName && item.imgLayer
                        ? item.imgLayer[currentSpecName]
                        : 1
                    "
                    :modelUrl="
                      currentSpecName && item.model_url
                        ? item.model_url[currentSpecName]
                        : []
                    "
                    :images="
                      currentSpecName && item.images
                        ? item.images[currentSpecName]
                        : []
                    "
                    :modelParams="modelParams"
                    @setEffectImg="(img) => (item.bigimg = img)"
                  >
                  </effect>
                </el-carousel-item>
              </el-carousel>
              <el-carousel
                :height="600 + 'px'"
                arrow="always"
                :autoplay="false"
                trigger="click"
                v-else-if="effectimg_type == 2"
              >
                <el-carousel-item
                  v-for="(item, index) in effectData"
                  :key="index"
                  :name="item.design_name"
                >
                  <effect
                    ref="effectRef"
                    :value="item"
                    :id="index"
                    :type="4"
                    @setEffectImg="setEffectThumbImg(index, $event)"
                  >
                  </effect>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
        </div>
      </div>
    </el-main>
  </el-container>
</template>
<script>
import FabricEditor from "./components/fabric-editor.vue";
import Effect from "./components/effect-preview.vue";
import md5 from "js-md5";
import { decryptPsdData, getTempTexture } from "@/utils/design/design";
import { otherGetRequest, deepClone } from "@/utils/util.ts";
import { apiDesignDetail } from "@/api/app";
import {
  apiModelDetail,
  apiModelDesignPartsLists,
  apiModelEffectLists,
} from "@/api/model";

export default {
  components: {
    FabricEditor,
    Effect,
  },

  data() {
    return {
      tempImages: [],
      editorTempImages: [],
      statusMsg: "",
      id: 0,
      timer: null,
      second: 0,
      workspaceWidth: 0,
      workspaceHeight: 0,
      designFaceShiftX: 0,
      designFaceShiftY: 0,
      canvasW: 650,
      canvasH: 650,
      zoomScale: 1,
      canvasArr: [],
      fabricCanvas: null,
      editor: null,
      effectRef: null,
      productInfo: {},
      faceIndex: 0,
      faceName: "",
      currentFace: {},
      designFaceData: [],
      effectData: [{}],
      currentSpecName: "",
      modelParams: {},
      design_url: "",
      target_type: 1,
      fontList: [],
      attrDesigns: [],
      model: null,
      defaultEffect: [],
      uniqueObj: [],
      colorTempImgs: [],

      effectimg_type: 1,
      showFaceArr: [],
      designDatas: {},
      isDesign: false,
      origin_images: [],
      useFontList: [],
    };
  },
  computed: {},
  watch: {
    faceIndex: {
      handler(val) {
        this.editor = this.$refs.editor[val];
        this.fabricCanvas = this.$refs.editor[val].canvas;
        this.currentFace = this.designFaceData[val];
        this.faceName = this.designFaceData[val].design_name;
      },
    },
  },
  methods: {
    isCommonDesignFace(item) {
      return (
        item.is_diy == 1 && item.content_type != 4 && item.content_type != 5
      );
    },
    faceIsShow(value) {
      if (value.content_type != 4) {
        if (this.showFaceArr.length > 0) {
          return this.showFaceArr.includes(value.design_name) ? true : false;
        }
        return true;
      } else {
        return false;
      }
    },

    async setEffectThumbImg(index, img) {
      this.$set(this.effectData[index], "preview_img", img);
      this.$set(this.effectData[index], "loaded", true);
    },
    setCanvas(index) {
      if (index == 0) {
        this.faceIndex = index;
      }
    },
    handleZoomChange(value) {
      const workspaceElement = document.getElementById("workspace");
      this.zoomScale = value;
      if (workspaceElement) {
        this.designFaceShiftX =
          (workspaceElement.offsetWidth - this.canvasW * value) / 2;
        this.designFaceShiftY =
          (workspaceElement.offsetHeight - this.canvasH * value) / 2;
      }
    },
    dealOtherImg() {
      this.fabricCanvas.getObjects().forEach((item) => {
        if (item.name == "accessories") {
          item.bringToFront();
        }
      });
    },
    async refreshTexture(faceIndex = null) {
      try {
        this.dealOtherImg();
        let faceName = this.designFaceData[faceIndex]["design_name"];
        const canvas = !faceIndex
          ? this.fabricCanvas
          : this.$refs.editor[faceIndex].canvas;
        let faceNames = this.designFaceData[faceIndex].correlation_face || [
          faceName,
        ];
        const updateEffectByModel = async (effectRef, name) => {
          try {
            let defaultBgColor = null;
            let defaultTexture = null;
            // 使用默认底色
            if (!canvas.backgroundColor && this.currentFace.bg_color) {
              defaultBgColor = this.currentFace.bg_color;
            }
            if (defaultBgColor) {
              canvas.setBackgroundColor(
                defaultBgColor,
                canvas.renderAll.bind(canvas),
              );
            }
            // 使用默认贴图
            if (this.currentFace.texture && this.currentFace.reserve_texture) {
              defaultTexture = this.currentFace.texture;
              await this.setDefaultTexture(defaultTexture);
            }
            const currentTexture = await getTempTexture({
              type: this.effectimg_type,
              canvas: canvas,
              layerData: null,
              designFaceShiftX: this.designFaceShiftX,
              designFaceShiftY: this.designFaceShiftY,
              canvasW: this.canvasW,
              canvasH: this.canvasH,
              zoomScale: this.zoomScale,
            });
            // 清除默认贴图
            if (defaultTexture) {
              await this.setDefaultTexture("");
            }
            // 清除默认底色
            if (defaultBgColor) {
              canvas
                .setBackgroundColor("", canvas.renderAll.bind(canvas))
                .renderAll();
            }
            await effectRef.modelAction("setMap", {
              name: name,
              url: currentTexture,
              remove_color: defaultBgColor,
            });
            return true;
          } catch (error) {
            console.error(error);
          }
        };

        // 模型 2D贴图
        if (this.effectimg_type == 1) {
          for (let [index, item] of this.effectData.entries()) {
            const effectRef = this.$refs.effectRef[index];
            await updateEffectByModel(effectRef, faceName);
          }
        } else {
          for (let [index, item] of this.effectData.entries()) {
            await this.setPsdEffectByOne(index, faceNames);
          }
        }
        return true;
      } catch (err) {
        throw err;
      }
    },
    setDefaultTexture(texture) {
      return new Promise((resolve, reject) => {
        fabric.Image.fromURL(
          texture,
          (img) => {
            this.fabricCanvas.setBackgroundImage(
              img,
              this.fabricCanvas.renderAll.bind(this.fabricCanvas),
              {
                scaleX: this.canvasW / img.width,
                scaleY: this.canvasH / img.height,
              },
            );
            resolve(true);
          },
          { crossOrigin: "anonymous" },
        );
      });
    },
    //属性
    restoreAttr() {
      return new Promise((resolve, reject) => {
        if (this.attrDesigns && this.attrDesigns.length > 0) {
          for (let attr of this.attrDesigns) {
            let parts = deepClone(attr.value.parts);
            switch (attr.type) {
              case 1:
                for (let index in this.effectData) {
                  for (let part of parts) {
                    this.$refs.effectRef[index].setModelColor({
                      name: part,
                      color: attr.value.value.color,
                    });
                  }
                }
                break;
              case 2:
                for (let index in this.effectData) {
                  for (let part of parts) {
                    this.$refs.effectRef[index].setModelColor({
                      name: part,
                      color: attr.value.value.color,
                    });
                  }
                }
                break;
              case 3:
                for (let index in this.effectData) {
                  for (let part of parts) {
                    this.$refs.effectRef[index].setNormalMap({
                      name: part,
                      img: attr.value.value.image,
                      repeat: attr.value.value.normalmapRepeat,
                      scale: attr.value.value.normalmapScale,
                    });
                  }
                }
                break;
              case 4:
                break;
              case 5:
                for (let index in this.effectData) {
                  for (let part of parts) {
                    this.$refs.effectRef[index].setMapTexture({
                      name: part,
                      url: attr.value.value.image,
                    });
                  }
                }
                break;
              case 6:
                for (let index in this.effectData) {
                  this.$refs.effectRef[index].switchModelByName({
                    parts: parts,
                    model_url: attr.value.value.model_url[index],
                  });
                }
                break;
            }
          }
          resolve(true);
        } else {
          resolve(true);
        }
      });
    },

    loadOldDesignDatas() {
      return new Promise((resolve, reject) => {
        fetch(this.design_url)
          .then((response) => response.json())
          .then((res) => {
            resolve(res.design);
          });
      });
    },

    async initEffectModel() {
      try {
        const promises = [];
        for (const i in this.effectData) {
          this.editorTempImages[i] = {};
          if (this.effectData[i].is_diy) {
            promises.push(this.$refs.effectRef[i].init());
          }
        }
        await Promise.all(promises);
      } catch (e) {
        console.log(e);
        throw e;
      }
    },

    async initEffectPsd() {
      try {
        const promises = [];
        for (const i in this.effectData) {
          this.editorTempImages[i] = {};
          if (this.effectData[i].psdData[this.currentSpecName]) {
            promises.push(
              this.$refs.effectRef[i].psdAction(
                "drawAllLayers",
                this.effectData[i].psdData[this.currentSpecName],
              ),
            );
          }
        }
        await Promise.all(promises);
      } catch (e) {
        console.log(e);
        throw e;
      }
    },

    async createDesignDatas(value) {
      try {
        const promises = [];
        for (let index in value) {
          let canvas = this.$refs.editor[index].canvas;
          let json = value[index];
          promises.push(this.loadFromJSON(canvas, json, index));
          await Promise.all(promises);
        }
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    loadFromJSON(canvas, json, index) {
      return new Promise(async (resolve, reject) => {
        canvas.loadFromJSON(json, async () => {
          canvas.renderAll();
          setTimeout(() => {
            resolve(true);
          }, 200);
        });
      });
    },

    async loadFont(value) {
      try {
        if (value.name === "Tiff-Heavy") {
          value.url =
            "https://fqpod.oss-cn-guangzhou.aliyuncs.com/uploads/fonts/20250707/35g685ip2h.woff2";
        }
        const font = new FontFace(value.name, `url(${value.url})`);
        const loadedFont = await font.load();
        document.fonts.add(loadedFont);
        return value.name;
      } catch (err) {
        console.error("加载字体失败:", err);
        throw err;
      }
    },
    async getCustomEffect() {
      try {
        const res = await fetch(this.design_url);
        const data = await res.json();
        if (data.defaultEffect && data.defaultEffect.length > 0) {
          for (let item of data.defaultEffect) {
            let i = item.num;
            let images =
              this.productInfo.design_effects[i]["images"].split(",");
            images[0] = item.bg_img;
            this.productInfo.design_effects[i]["images"] = images.join(",");
          }
        }
        return;
      } catch (error) {}
    },
    createDesignFaces(designFaceList) {
      return new Promise((resolve, reject) => {
        const faceData = [];
        const modelParams = {};
        for (const index in designFaceList) {
          const face = designFaceList[index];
          let cloneData = deepClone(face);
          if (cloneData.design_name.indexOf(",") > -1) {
            const design_names = cloneData.design_name.split(",");
            cloneData.design_name = design_names[0];
            cloneData.correlation_face = design_names;
          }
          if ([1, 3].indexOf(face.is_diy) > -1) {
            if (cloneData.more_spec == 1) {
              let sku_diy_data = JSON.parse(deepClone(cloneData.sku_diy_data));
              let currentData = sku_diy_data.find(
                (item) => item.name == this.currentSpecName,
              );
              cloneData = { ...cloneData, ...currentData };
            }
            const {
              design_size,
              production_size,
              recommend_size,
              crop_size,
              dotted_size,
            } = cloneData;
            const designSize = design_size.split("|");
            cloneData.maxwidth = designSize[0];
            cloneData.maxheight = designSize[1];
            const productionSize = production_size.split("|");
            cloneData.productionWidth = productionSize[0];
            cloneData.productionHeight = productionSize[1];
            const dottedSize = dotted_size.split("|");
            cloneData.dottedWidth = dottedSize[0];
            cloneData.dottedHeight = dottedSize[1];
            cloneData.crop_size = crop_size.split("|");
            cloneData.printquality = "";
            cloneData.recommend_size = recommend_size
              ? recommend_size.split("x").map(Number)
              : ["", ""];
            cloneData.design_full = 0; //1未铺满2已铺满
            faceData.push(cloneData);
            const modelData = deepClone(face);
            if (modelData.normalmap) {
              const normalmap = JSON.parse(modelData.normalmap);
              modelData.normalMap = {
                img: normalmap.img,
                repeat: normalmap.repeat,
                scale: normalmap.scale,
              };
            } else {
              modelData.normalMap = null;
            }
            modelData.default_texture = modelData.texture;
            modelParams[face.design_name] = modelData;
          } else {
            if (cloneData.normalmap) {
              const normalmap = JSON.parse(cloneData.normalmap);
              cloneData.normalMap = {
                img: normalmap.img,
                repeat: normalmap.repeat,
                scale: normalmap.scale,
              };
            } else {
              cloneData.normalMap = null;
            }
            modelParams[face.design_name] = cloneData;
          }
        }
        this.designFaceData = faceData;
        this.modelParams = modelParams;
        resolve(true);
      });
    },

    createEffectDatas(effectRes) {
      return new Promise((resolve, reject) => {
        let effectArr = [];
        if (effectRes.length > 0) {
          for (const i in effectRes) {
            const item = deepClone(effectRes[i]);
            let images = {};
            let model_url = {};
            let imgLayer = {};
            if (item.more_spec == 1) {
              for (let skuData of JSON.parse(deepClone(item.sku_diy_data))) {
                images[skuData.name] = skuData.images;
                model_url[skuData.name] = skuData.model;
                imgLayer[skuData.name] = Number(skuData.img_layer);
              }
            } else {
              let imageTemp = deepClone(item.images)
                ? deepClone(item.images).split(",")
                : [];
              for (let spec of this.productInfo.spec_value_list) {
                images[spec.spec_value_str] = imageTemp;
                model_url[spec.spec_value_str] = JSON.parse(item.model_url);
                imgLayer[spec.spec_value_str] = Number(item.img_layer);
              }
            }
            item.images = images;
            item.model_url = model_url;
            item.imgLayer = imgLayer;
            item.currentImgs = images[this.currentSpecName];
            item.currentImgIndex = imgLayer[this.currentSpecName];
            item.preview_img = "";
            item.preview_loaded = false;
            item.model_json = "";
            effectArr.push(item);
          }
          this.effectData = effectArr;
        }
        resolve(true);
      });
    },

    // 获取用户自定义PSD定制效果数据
    getCustomEffectByPSD() {
      return new Promise((resolve, reject) => {
        let params = { id: this.$route.query.id };
        otherGetRequest(`/goods.goodsDesignTask/getGoodsPsdDataList`, params, {
          sign: md5(
            JSON.stringify(params) + "332994CF-622B-44FB-82DD-C11B1FFD95B5",
          ),
        })
          .then((res) => {
            console.log("🚀 ~ res:", res);
            let data = res
              .filter((item) => item.status == 1)
              .map((item) => {
                return JSON.parse(item.psd_data);
              });
            resolve(data);
          })
          .catch((err) => {
            resolve([]);
            console.log("🚀 ~ err:", err);
          });
      });
    },
    async createEffectDatasType2(effectRes) {
      try {
        let effectResCopy = deepClone(effectRes);
        let customEffect = await this.getCustomEffectByPSD();
        effectResCopy = [...effectResCopy, ...customEffect];
        for (const [index, item] of effectResCopy.entries()) {
          let psdData = {};
          const psd = JSON.parse(item.psd);
          const promises = [];
          for (const [n, v] of psd.entries()) {
            promises.push(decryptPsdData(v.url));
          }
          const psdParse = await Promise.all(promises);
          if (item.more_spec == 1) {
            for (const [n, v] of psdParse.entries()) {
              psdData[psd[n].sku] = v;
            }
          } else {
            this.productInfo.spec_value_list.forEach((item) => {
              psdData[item.spec_value_str] = psdParse[0];
            });
          }

          item.psdData = psdData;
        }
        this.effectData = effectResCopy;
        return;
      } catch (error) {
        console.log("🚀 ~ error:", error);
      }
    },

    getDesignFace(face, indexArr) {
      if (indexArr && indexArr.length > 0) {
        return face.filter(
          (item, index) => item.is_diy == 1 && indexArr.includes(index),
        );
      }
      return face.filter((item) => item.is_diy == 1);
    },

    async setPsdEffectByOne(effect_index, faceNames) {
      try {
        let groups = [];
        let faceDatasArr = this.getDesignFace(this.designFaceData);
        let faceDatas =
          faceNames && faceNames.length
            ? [faceDatasArr.find((item) => item.design_name == faceNames[0])]
            : faceDatasArr;
        const groupSize = 10;
        for (let i = 0; i < faceDatas.length; i += groupSize) {
          groups.push(faceDatas.slice(i, i + groupSize));
        }
        for (let group of groups) {
          let promise = [];
          for (let val in group) {
            const index = this.designFaceData.findIndex(
              (item) => item.id == group[val].id,
            );
            let correlation_face =
              deepClone(this.designFaceData[index].correlation_face) || [];
            if (!correlation_face.length) {
              correlation_face.push(this.designFaceData[index].design_name);
            }
            promise.push(
              this.updateEffectByPsd(
                this.$refs.editor[index].canvas,
                effect_index,
                correlation_face,
              ),
            );
          }
          await Promise.all(promise);
        }
        if (faceNames && faceNames.length) {
          await this.$refs.effectRef[effect_index].psdAction(
            "replaceImage",
            faceNames,
          );
        } else {
          await this.$refs.effectRef[effect_index].psdAction(
            "drawAllLayers",
            this.effectData[effect_index].psdData[this.currentSpecName],
          );
        }
        this.$refs.effectRef[effect_index].loading = false;
        this.effectData[effect_index].loaded = true;
      } catch (error) {}
    },
    async updateEffectByPsd(canvas, effectIndex, nameArr) {
      let defaultBgColor = null;
      let defaultTexture = null;
      let currentTexture = "";
      // 使用默认底色
      if (!canvas.backgroundColor && this.currentFace.bg_color) {
        defaultBgColor = this.currentFace.bg_color;
      }
      if (defaultBgColor) {
        canvas.setBackgroundColor(
          defaultBgColor,
          canvas.renderAll.bind(canvas),
        );
      }
      // 使用默认贴图
      if (this.currentFace.texture && this.currentFace.reserve_texture) {
        defaultTexture = this.currentFace.texture;
        await this.setDefaultTexture(defaultTexture);
      }
      const layerData = this.effectData[effectIndex].psdData[
        this.currentSpecName
      ].psdDatas.find((item) => item.N === nameArr[0]);
      if (layerData) {
        currentTexture = await getTempTexture({
          type: this.effectimg_type,
          canvas: canvas,
          layerData: layerData,
          designFaceShiftX: this.designFaceShiftX,
          designFaceShiftY: this.designFaceShiftY,
          canvasW: this.canvasW,
          canvasH: this.canvasH,
          zoomScale: this.zoomScale,
        });
      }
      // 清除默认贴图
      if (defaultTexture) {
        await this.setDefaultTexture("");
      }
      // 清除默认底色
      if (defaultBgColor) {
        canvas
          .setBackgroundColor("", canvas.renderAll.bind(canvas))
          .renderAll();
      }
      for (let name of nameArr) {
        await this.$refs.effectRef[effectIndex].psdAction(
          "createTextureByFace",
          {
            texture: currentTexture,
            name: name,
          },
        );
      }
    },
    //根据设计面批量刷新效果图
    async refreshDesignByFace() {
      try {
        if (this.effectimg_type == 1) {
          const promises = [];
          for (let [index, item] of this.designFaceData.entries()) {
            promises.push(this.refreshTexture(index));
          }
          await Promise.all(promises);
        } else {
          for (let index in this.effectData) {
            await this.setPsdEffectByOne(index);
          }
        }
      } catch (error) {
        console.log("🚀 ~ error:", error);
      }
    },
    downloadOriginImage() {
      for (let item of this.origin_images) {
        window.open(item);
      }
    },
  },

  async mounted() {
    const workspaceElement = document.getElementById("workspace");
    if (workspaceElement) {
      this.workspaceWidth = workspaceElement.offsetWidth;
      this.workspaceHeight = workspaceElement.offsetHeight;
    }
    let params = { id: this.$route.query.id };
    const res = await apiDesignDetail({ id: params.id });
    this.design_url = res.design.design_url;
    this.fontList = res.design.fonts.filter((item) =>
      item.url.includes("http"),
    );
    this.currentSpecName = res.design.spec_value_str;
    this.id = params.id;
    this.design_url = res.design.design_url;
    const modelRes = await apiModelDetail({ id: res.design.model_id });
    this.productInfo = modelRes;
    this.effectimg_type = modelRes.effectimg_type;
    if (this.fontList.length > 0) {
      const promises = [];
      for (let font of this.fontList) {
        promises.push(this.loadFont(font));
      }
      await Promise.all(promises);
    }

    await this.getCustomEffect();
    let designRes = await apiModelDesignPartsLists({
      model_id: res.design.model_id,
      sort: "sort desc",
    });
    let design_parts = designRes.lists;
    let effectsRes = await apiModelEffectLists({
      model_id: res.design.model_id,
      sort: "sort desc",
    });
    let design_effects = effectsRes.lists;
    this.productInfo.design_parts = design_parts;
    this.productInfo.design_effects = design_effects;
    //初始定制数据
    if (this.effectimg_type == 1) {
      await Promise.all([
        this.createDesignFaces(design_parts),
        this.createEffectDatas(design_effects),
      ]);
    } else {
      await Promise.all([
        this.createDesignFaces(design_parts),
        this.createEffectDatasType2(design_effects),
      ]);
    }
    //初始效果图模型读取定制JSON
    let result = await Promise.all([
      this.effectimg_type == 1 ? this.initEffectModel() : this.initEffectPsd(),
      this.loadOldDesignDatas(this.design_url),
    ]);
    let designDatas = result[1];
    this.designDatas = designDatas;
    console.log("🚀 ~ this.designDatas:", this.designDatas);
    this.isDesign = false;
    let useFontList = [];
    let origin_images = [];
    for (const designItem of this.designDatas) {
      for (const objectItem of designItem.objects) {
        if (objectItem.name === "customize") {
          this.isDesign = true;
          if (objectItem.type == "image") {
            origin_images.push(objectItem.src);
          } else if (objectItem.type == "text") {
            useFontList.push(objectItem.fontFamily);
          }
        }
      }
    }
    this.useFontList = [...new Set(useFontList)];
    this.origin_images = [...new Set(origin_images)];
    this.editor = this.$refs.editor[0];
    this.fabricCanvas = this.$refs.editor[0].canvas;
    this.currentFace = this.designFaceData[0];
    this.faceName = this.designFaceData[0].design_name;
    //加载属性
    await this.restoreAttr();
    //恢复定制面数据
    await this.createDesignDatas(designDatas);
    await this.refreshDesignByFace();
  },
};
</script>
<style lang="scss" scoped>
.product-info {
  position: absolute;
  left: 20px;
  top: 20px;
  display: flex;
  font-size: 16px;
  font-weight: bold;
  z-index: 100;
}
.origin-imgs {
  position: absolute;
  left: 20px;
  top: 40px;
  display: flex;
  z-index: 100;
}
.font-list {
  position: absolute;
  left: 20px;
  top: 110px;
  display: flex;
  gap: 10px;
  z-index: 100;
  align-items: center;
}
.design-workspace {
  width: calc(100% - 620px);
  height: 100%;
  position: relative;
  display: flex;
}
.design-face-cont {
  position: absolute;
  left: 30px;
  top: 140px;
  z-index: 100;
  height: 700px;
  overflow: auto;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
  .design-face-item {
    width: 80px;
    height: 82px;
    margin: 0 auto 10px auto;
    border: 1px solid #eee;
    border-radius: 5px;
    padding: 1px;
    box-sizing: border-box;
    cursor: pointer;

    ::v-deep .el-button {
      border-radius: 5px;
    }

    &:first-child {
      margin-top: 10px;
    }

    &:last-child {
      margin-bottom: 10px;
    }

    &:hover {
      border-color: var(--color-primary);
    }

    &.on {
      border-color: var(--color-primary);
    }

    img {
      width: 100%;
      height: 100%;
      border-radius: inherit;
    }
  }
}
.editor-canvas {
  width: 100%;
  height: 100%;
  position: relative;

  .mask-img {
    position: absolute;
    z-index: 1;
    pointer-events: none;
  }
  .editor-canvas {
    width: 100%;
    height: 100%;
    position: relative;
  }
  .editor-canvas-bg {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    --offsetX: 0px;
    --offsetY: 0px;
    --size: 16px;
    --color: #dedcdc;
    background-image: linear-gradient(
        45deg,
        var(--color) 25%,
        transparent 0,
        transparent 75%,
        var(--color) 0
      ),
      linear-gradient(
        45deg,
        var(--color) 25%,
        transparent 0,
        transparent 75%,
        var(--color) 0
      );
    background-position: var(--offsetX) var(--offsetY),
      calc(var(--size) + var(--offsetX)) calc(var(--size) + var(--offsetY));
    background-size: calc(var(--size) * 2) calc(var(--size) * 2);
  }
}
.design--right {
  box-sizing: border-box;
  background: #fff;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 620px;
  transition: width 0.3s ease-in-out;
}
::v-deep .el-carousel {
  .el-carousel__button {
    background-color: #479ceb;
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }
  .is-active {
    .el-carousel__button {
      background-color: #479ceb;
    }
  }
}
</style>
